import React from 'react';

import { twMerge } from 'tailwind-merge';

import { Menu } from '@headlessui/react';

import Typography from 'components-new/typography/typography';

export type DropdownMenuItemType = {
  // eslint-disable-next-line react/no-unused-prop-types
  key: string;
  label?: string;
  type?: 'item' | 'divider';
  variant?: 'normal' | 'destructive';
  leadingElement?: React.ReactElement;
  onClick?: () => void;
  className?: string;
};

const DropdownMenuItem: React.FC<DropdownMenuItemType> = ({
  label,
  type = 'item',
  variant = 'normal',
  leadingElement,
  onClick,
  className,
}) => {
  const containerClassName = twMerge(
    'appearance-none w-full flex items-center px-2 py-0.5 rounded group',
    variant === 'normal' &&
      'hover:bg-background-hover focus:bg-background-pressed text-gray-600 group-focus:text-gray-800',
    variant === 'destructive' &&
      'hover:bg-background-hoverDestructive focus:bg-background-pressedDestructive text-destructive-400 group-focus:text-destructive-500',
    className,
  );
  if (type === 'divider') {
    return (
      <Menu.Item>
        <div className="h-4" />
      </Menu.Item>
    );
  }
  return (
    <Menu.Item>
      <button type="button" className={containerClassName} onClick={onClick}>
        <span className="w-[20px] mr-1.5 flex items-center justify-center">
          {leadingElement && leadingElement}
        </span>
        <Typography variant="ui-input" as="span" className="text-start">
          {label}
        </Typography>
      </button>
    </Menu.Item>
  );
};

export default DropdownMenuItem;
